export function Plus(props: { color: string }) {
  return (
    <svg
      // className="inline stroke-primary dark:stroke-primaryDark"
      className={`inline ${props.color}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 5V19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 12H19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
